<h1>{{ 'turbo.Bookings.AddCostDialog.lblHeadline2' | translate:'Add cost' }}</h1>
<mat-dialog-content style="min-width: 400px;">
  <t4-container>
    <ng-container>
      <div class="row">
        <div class="col-12" style="white-space:nowrap">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'turbo.Bookings.AddCostDialog.lblItemType' | translate : 'Item type'}}</mat-label>
            <mat-select [ngModel]="selectedType" (ngModelChange)="selectType($event)">
              <mat-option [value]="3">{{ 'turbo.Bookings.AddCostDialog.valDefault' | translate : 'Default' }}</mat-option>
              <mat-option [value]="2">{{ 'turbo.Bookings.AddCostDialog.valAddons' | translate : 'Addons' }}</mat-option>
              <mat-option [value]="1">{{ 'turbo.Bookings.AddCostDialog.valSpareParts' | translate : 'Spare parts' }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="white-space:nowrap">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'turbo.Bookings.AddCostDialog.lblItemId' | translate : 'ItemId'}}</mat-label>
            <mat-select [ngModel]="selectedItem" (ngModelChange)="selectItem($event)">
              <mat-option *ngFor="let item of items" [value]="item">
                {{item.Title}}
              </mat-option>
            </mat-select>
            <mat-suffix *ngIf="isLoadingItems"><mat-icon>save</mat-icon></mat-suffix>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-12" style="white-space:nowrap">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'turbo.Bookings.AddCostDialog.txtAmount' | translate : 'Amount incl. VAT'}}</mat-label>
            <input #txtInput type="number" required matInput [(ngModel)]="amount">
            <mat-error>{{ 'turbo.Bookings.RefundDialog.errRefundAmountInvalid' | translate : 'Invalid amount'}}</mat-error>
          </mat-form-field>
        </div>
        <div class="col-12" style="white-space:nowrap">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'turbo.Bookings.AddCostDialog.txtDescription' | translate : 'Description'}}</mat-label>
            <input #txtInput type="text" maxlength="50" matInput [(ngModel)]="description">
            <mat-error>{{ 'turbo.Bookings.RefundDialog.errRefundDescriptiontInvalid' | translate : 'Invalid description'}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </ng-container>
  </t4-container>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-xs-12" style="text-align: center">
    <button mat-flat-button color="primary" style="margin: 3px;" (click)="validate()">{{ 'turbo.Bookings.AddCostDialog.cmdConfirm' | translate : 'Ok'}}</button>
  </div>
</mat-dialog-actions>
